<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <v-row no-gutters>
        <v-col cols="12" md="10">
          <h1 class="text-h1 mb-2" >{{db.name}}</h1>
        </v-col>
        <v-col cols="12" md="2" class="hidden-sm-and-down" justify="end">
          <DbLangOpts v-if="$vuetify.breakpoint.mdAndUp" :abbr="db.abbr" :curLang="db.lang"></DbLangOpts>
        </v-col>
      </v-row>
    </template>

    <template v-slot:leftPanel  v-if="$vuetify.breakpoint.mdAndUp">
      <StatusWidget :statinfo="stat_wdgt" />
    </template>

    <template v-slot:mainPanel>
      <!--Filter Box-->
      <v-card flat class="dbfilterbox lsidebg pl-5 pr-3 pt-2 pb-1 mb-6 d-print-none" max-width="850">
      
        <v-card-title class="px-0 py-0 mb-2">
          <h3 class="text-h6 font-italic pt-1">{{$t('database.filter')}}</h3>
        </v-card-title>
            
        <!--row 1: citation filter-->  
        <v-row no-gutters class="my-2">
          <v-col cols="12" md="4" sm="5" class="my-2">
            <v-text-field
              class="pr-5 py-0 shrink"
              v-model="actno"
              :label="$i18n.t('database.action')"
              prepend-icon="mdi-gavel"
              hide-details dense clearable
              color="link"
              @keyup.enter="go_search"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="5" sm="5" class="my-2">
            <v-text-field
              class="pl-lg-5 pr-5 py-0 shrink"
              v-model="neucit"
              :label="$i18n.t('search.advs.neutral')"
              prepend-icon="mdi-code-brackets"
              hide-details dense clearable
              color="link"
              @keyup.enter="go_search"
            ></v-text-field>
          </v-col>

          <!--Apply button for larger screens-->
          <v-col cols="12" md="3" sm="2" v-if="$vuetify.breakpoint.mdAndUp" class="pr-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-btn
                  class="link lighten-5 px-lg-8"
                  outlined
                  color="link" 
                  @click="go_search"
                  max-width="150px"
                >
                  <v-icon small class="mr-3">mdi-filter-variant</v-icon>
                  {{$t('btntxt.apply')}}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!--row 2: keyword filter-->
        <v-row no-gutters class="my-2">
          <v-col cols="12" md="9" sm="10" >
            <v-text-field
              class="pr-5 py-0 shrink"
              v-model="search"
              :label="$i18n.t('database.casename')"
              prepend-icon="mdi-text"
              hide-details dense clearable
              color="link"
              @keyup.enter="go_search"
            ></v-text-field>
          </v-col>
        </v-row>

        <!--row 3: date filter-->
        <v-row no-gutters class="mt-2">
          <v-col cols="12" sm="4" class="my-2">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              offset-overflow
              max-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="min_date_text"
                  :label="$i18n.t('database.startdate')"
                  v-bind="attrs"
                  v-on="on"
                  hint="DD/MM/YYYY format"
                  clearable dense
                  @blur="min_date=parse_date(min_date_text); min_date_text=format_date(min_date)"
                  :readonly="$vuetify.breakpoint.xsOnly"
                  class="pr-5 py-0 shrink"
                  color="link"
                  prepend-icon="mdi-calendar-start"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="min_date"
                no-title
                min="1860-01-01"
                :max="today"
                @input="menu=false; min_date_text=format_date(min_date)"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="1" class="my-2 text-center pr-5 pt-2" v-if="!$vuetify.breakpoint.xsOnly">
            <span class="text-darkgrey text-body-2 "> {{$t('database.filter_to')}} </span>
          </v-col>

          <v-col cols="12" md="4" sm="5" class="my-2">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              offset-overflow
              max-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="max_date_text"
                  :label="$i18n.t('database.enddate')"
                  v-bind="attrs"
                  v-on="on"
                  hint="DD/MM/YYYY format"
                  clearable dense
                  @blur="max_date=parse_date(max_date_text); max_date_text=format_date(max_date)"
                  :readonly="$vuetify.breakpoint.xsOnly"
                  class="pr-5 py-0 shrink"
                  color="link "
                    prepend-icon="mdi-calendar-end"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="max_date"
                no-title
                min="1860-01-1"
                :max="today"
                @input="menu2=false; max_date_text=format_date(max_date)"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
                    
        <!--Apply Button for small screens-->
        <v-row no-gutters v-if="$vuetify.breakpoint.smAndDown">
          <v-btn
            class="px-8 mt-0 mb-2 link lighten-5"
            outlined 
            color="link" 
            @click="go_search"
            >
            <v-icon small class="mr-3">mdi-filter-variant</v-icon>
            {{$t('btntxt.apply')}}
          </v-btn>
        </v-row>
      </v-card>

      <!--Found Records-->
      <v-card color="lsidebg" class="elevation-2">
        <v-data-table
          :headers="headers"
          :items="files"
          calculate-widths hide-default-footer
          :items-per-page="show_max_dbs.includes(db.abbr) ? 500 : 100"
          :options.sync="options"
          :server-items-length="totalFiles"
          :loading="loading"
          :page.sync="page"
          @page-count="pageCount = $event"
          class="casetoc dbtoc"
          dense
          :loading-text="$i18n.t('database.loading')"
          :no-data-text="$i18n.t('error.nodata_warn')"
          :no-results-text="$i18n.t('error.noresult_warn')"
          :header-props="{'sort-by-text':$i18n.t('database.sortby')}"
        >

          <!--header pagination--> <!--REWRITE THIS. find a way to implement the card pagination-->
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-data-footer 
              show-current-page show-first-last-page
              :pagination="pagination" 
              :options="options"
              @update:options="updateOptions"
              :items-per-page-options="[20, 50, 100, 500]"
              :items-per-page-text="$t('tbhead.itemperpage')"
            />
          </template>

          <!--click on text instead of @click:row.capture="goFile" so text could be highlighted-->
          <template v-slot:item="{item}">
            <tr v-if="$vuetify.breakpoint.smAndUp" @click="(event)=>goFile(item, event)" ><!--desktop TOC-->
              <td class="pr-1">
                <router-link :to="{path: item.path}" class="routing" v-html="item.title"></router-link>
              </td>
              <td class="pr-1">
                <router-link :to="{path: item.path}" class="routing" v-html="item.citation"></router-link>
              </td>
              <td class="pr-1">
                <router-link :to="{path: item.path}" class="routing" v-html="item.acts"></router-link>
              </td>
                <td class="dt-date pr-3">
                <router-link :to="{path: item.path}" class="routing" v-html="item.date"></router-link>
              </td>
            </tr>
            <tr v-else @click="(event)=>goFile(item,event)"> <!--mobile TOC-->
              <td>
                <router-link class="routing" :to="{path: item.path}"> <!--mobile TOC-->
                  <span class="mobiledt_subinfo mobiledt_label mr-2" v-html="item.citation"></span>
                  <span class="mobiledt_subinfo mobiledt_darker" v-html="item.m_acts"></span><br>
                  <span class="mobiledt_subinfo" v-html="item.date"></span><br>
                  <span class="mobiledt_title" v-html="item.title"></span>
                </router-link>
              </td>
            </tr>
          </template>
        </v-data-table>

        <!--bottom pagination--> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-pagination 
              v-model="page"
              color="link lighten-1"
              :length="pageCount" 
              :total-visible="7"
          ></v-pagination>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-card>

    </template>

    <template v-slot:rightPanel>
      <InfoWidget v-if="db.about" :title="`${$t('database.aboutdb')} ${db.name} ${$t('home.judgments')}`" :content='db.about' />
      <InfoWidget v-if="db.cright" :title="$t('database.cright')" :content='db.cright' />
    </template>
  </ThreeColumn>
</template>

<script>
  import api from '@/scripts/api'
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import StatusWidget from '../components/StatusWidget'
  import InfoWidget from '../components/InfoWidget'
  import DbLangOpts from '../components/DbLangOpts'
  import dbs from '../data/dbs.json'
  import datehelper from '@/scripts/datehelper'
  export default {
    name:'database',
    components: {
      ThreeColumn,
      StatusWidget,
      InfoWidget,
      DbLangOpts
    },
    data () {
      return {
        min_date:null,
        max_date:null,
        min_date_text:'',
        max_date_text:'',
        dates: [],
        show_max_dbs: [],  // dbs that shows all rows initially
        today: datehelper.today_str(),
        menu: false,
        menu2:false,
        modal: false,
        search: '',
        awaitingSearch: false,
        dbs:dbs,
        db: {
            id:0,
            abbr:'',
            name:'',
            about:'',
            cright:'',
            cat:''
        },
        page:1,
        pageCount:0,
        totalFiles: 0,
        files: [],
        loading: true,
        options: {},
        stat_wdgt:[],
        neucit:'', //fitering field
        actno:'', //fitering field
      }
  },
  watch: {
    'options.page':function(newV,oldV){
      if (Boolean(oldV)&&(newV != oldV)){
      this.get_files()
        window.scrollTo(0,0)
      }
    },
    'options.itemsPerPage':function(newV,oldV){
      if (Boolean(oldV)&&(newV != oldV)) {
        this.get_files()
      }
    },
    sort_str(){
      this.options.page = 1
      this.get_files()
    },
    '$route': function(){
      this.db = this.dbs.find(db => db['path'] == this.$route['fullPath'])
      this.options.page = 1
      this.get_files()
    }
  },
  methods:{
    parse_date: datehelper.parse_date,
    format_date: datehelper.format_date,
    go_search(){
      this.options.page = 1
      this.get_files()
    },
    async get_metadata(){
      try {
        const res = await api.get_metacase(this.db.abbr, this.db.lang)
        this.stat_wdgt.push({label:this.$i18n.t('database.wdg_status_filecount'),val: res['count'], unit:this.$i18n.t('database.wdg_status_fileunit')})
        this.stat_wdgt.push({label:this.$i18n.t('database.wdg_status_updatetime'),val:datehelper.display_date(res['timestamp'])})
      } catch (err){
        console.error(err)
      }
    },
    async get_files(){
      this.loading = true
      var params = {
        'caseDb': this.db.abbr,
        'lang': this.db.lang,
        'itemsPerPage': this.options.itemsPerPage,
        'page': this.options.page,
        'act': this.actno ? this.actno.trim() : '',
        'neutral': this.neucit ? this.neucit.trim() : '',
        'title': this.search ? this.search.trim() : '',
        'minDateText': this.min_date_text,
        'maxDateText': this.max_date_text,
        'sort': this.sort_str
      }
      try {
        const res = await api.get_casefiles(params)
        this.totalFiles = res['totalfiles']
        if (this.totalFiles > 0){
          this.files = res['judgments'].map(file => {
            var jud = Object()
            jud['date'] = datehelper.display_date(file['date'])
            jud['citation'] = [file['neutral']].concat(file['parallel']).join('<br/>')
            jud['acts'] = file['cases'].map(c => c.act).join('<br/>')
            jud['m_acts'] = file['cases'].map(c => c.act).join('; ')
            jud['path'] = file['path']
            // only keep unique copies of tiles to concise
            var titles = []
            file['cases'].forEach(c => {
              if (!titles.includes(c.title)){
                titles.push(c.title)
              }
            })
            jud['title'] = titles.join('<br/>')
            return jud;
          })
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    goFile(item, event){
      var selectedText = getSelection().toString()
      if (selectedText.length == 0 && event.target.tagName !== "A"){
        let routeData = this.$router.resolve({path: item.path});
        if (event.ctrlKey){
          // Ctrl + click: open in new tab
          var w = window.open(routeData.href, '_blank')
          if (event.shiftKey){
            // Ctrl + Shift + click: open in new tab and focus
            w.focus()
          }
        } else if (event.shiftKey){
          // Shift + click: open in new tab
          window.open(routeData.href)
        } else {
          this.$router.push({path: item.path})
        }
      }
    }
  },
  computed:{
    sort_str(){
      if (!this.options.sortBy || this.options.sortBy.length == 0){
        return ''
      } else {
        // sort one field only
        var s = this.options.sortBy[0]
        if (this.options.sortDesc[0]){
          s = '-' + s
        }
        return s
      }
    },
    date_sort(){
      if (this.sort.field === 'date'){
        return this.sort.order
      } else {
        return 'desc'
      }
    },
    paths(){
      return [
        {text: 'HKLII', disabled: false, href: {name: 'home'}},
        {text: this.$i18n.t('database.dbs'), disabled: false, href: {name: 'databases'}},
        {text: this.db.name, disabled: true}
      ]
    },
    headers(){
      return [
        { text: this.$i18n.t('database.casename'), value: 'title', sortable: false},
        { text: this.$i18n.t('database.wdg_jdg_neutral'), value: 'citation',sortable: false, width:'20%'},
        { text: this.$i18n.t('database.action'), value: 'acts',sortable: false, width:'16%'},
        { text: this.$i18n.t('database.date'), value: 'date', width:'14%'}
      ]
    },
    },
    beforeMount(){
      // setting up the pagination
      this.db = this.dbs.find(db => db['path'] === this.$route['fullPath'])
    },
    mounted(){
      this.get_metadata()
      this.get_files()
      //window.document.title = this.db.name + ' | HKLII'
    },
    metaInfo(){
      return{
        title: this.db.name,
        meta: [
          {
            name: 'description',
            content: 'Database of judgments from ' + this.db.name + ' of Hong Kong.',
          }
        ],
      }
    },
  }
</script>

<style scoped>

  .dbfilterbox{
    border-left: 3px solid var(--v-l_case-base) !important;
  }

  .mobiledt_label{
    background-color: var(--v-l_case-base);
    color: var(--v-liiblack-base);
    padding-left:8px;
    padding-right:8px;
    border-radius: 20px;
    box-decoration-break: clone;
  }

  .dt-date{
    /*font-size: 0.8rem !important;*/
    letter-spacing: -0.15pt !important;
  }

</style>